import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StoreState } from '../../../store/reducer-main';
import { Button as NUIButton, DateInput, DateValue, Input, Select, Selection, SelectItem, Switch, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Textarea } from '@nextui-org/react';
import { CalendarDate, RateSelectorValue, Trait, TraitData, UsefulInfo } from '../../../types/common';
import { DEFAULT_COMMON_USEFUL_INFO, KNOWEDGE_SELECTOR_DATA, RATE_SELECTOR_VALUES, TRAITS, TRAITS_SELECTOR_DATA } from '../../../constants/common';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CARE_GIVER_PERSONALITIES_SELECTOR_DATA, /* CARE_GIVER_YEARS_OF_EXPERIENCE,  */CAREGIVER_COVERAGE_AVAILABILITY, CAREGIVER_NATIONALITIES_SELECTOR_DATA, CAREGIVER_OTHER_PEOPLE_PRESENCE, CAREGIVER_PERSONALITIES, CAREGIVER_SMOKES, CAREGIVER_WEEKEND_AVAILABILIY, CAREGIVERS_NIGHT_TIME } from '../../../constants/caregivers';
import RateSelector from '../../components/common/RateSelector';
import { brkRef, calendarDate2Timestamp } from '../../../helpers/utils';
import { CareGiverCovergaeAvailability, CareGiverFormData, CaregiverNationality, CareGiverNightTime, CareGiverOtherPeoplePresence, CareGiverPeronality, CareGiverPersonalData, CaregiverPersonalityData, CareGiverSmokes, CareGiverWeekendAvailability, CareGiverYearsOfExperience } from '../../../types/caregivers';
import { createUserCareGiver } from '../../../service/caregiovers';
import Typography from '../../components/common/Typography';
import IconButton from '../../components/common/IconButton';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import theme from '../../theme';
import Button from '../../components/common/Button';
import PageLayout from '../../components/common/PageLayout';
import { toast } from 'react-toastify';
import CustomModal from '../../components/common/CustomModal';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

const persone = [ // per test
  { nome: "Mario", cognome: "Rossi" },
  { nome: "Luigi", cognome: "Bianchi" },
  { nome: "Anna", cognome: "Esposito" },
  { nome: "Sara", cognome: "Ferri" },
  { nome: "Giovanni", cognome: "Romano" },
  { nome: "Paolo", cognome: "Santoro" },
  { nome: "Francesca", cognome: "Gatti" },
  { nome: "Carlo", cognome: "Barbieri" },
  { nome: "Elena", cognome: "Moretti" },
  { nome: "Marco", cognome: "Monti" },
  { nome: "Alessia", cognome: "Fontana" },
  { nome: "Giorgio", cognome: "Costa" },
  { nome: "Lucia", cognome: "Martini" },
  { nome: "Claudio", cognome: "Greco" },
  { nome: "Valeria", cognome: "De Luca" },
  { nome: "Stefano", cognome: "Marini" },
  { nome: "Simona", cognome: "Lombardi" },
  { nome: "Federico", cognome: "Conti" },
  { nome: "Martina", cognome: "Ricci" },
  { nome: "Davide", cognome: "Pellegrini" }
];


export default function CreateCareGiverPage() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userProfile } = useSelector((state: StoreState) => state.profile);
  const { tablePaginationConfig } = useSelector((state: StoreState) => state.caregivers);

  const [loading, setLoading] = React.useState<boolean>(false);
  /* ANAGRAFICA */
  const [name, setName] = React.useState<string>('');
  const [surname, setSurname] = React.useState<string>('');
  const [address, setAddress] = React.useState<string>('');
  const [birthDate, setBirthDate] = React.useState<DateValue | undefined>(undefined);
  const [telephone, setTelephone] = React.useState<string>('');
  const [nationality, setNationality] = React.useState<Selection>(new Set([]));
  const [references, setReferences] = React.useState<boolean>(false);
  const [distanceFromFamily, setDistanceFromFamily] = React.useState<string>('');
  const [coverageAvailability, setCoverageAvailability] = React.useState<Selection>(new Set([]));
  /* ESPERIENZE E CONOSCENZE */
  const [yearsOfExperience, setYearsOfExperience] = React.useState<string>('');
  const [languageKnowledge, setLanguageKnowledge] = React.useState<Selection>(new Set([]));
  const [cookingKnowledge, setCookingKnowledge] = React.useState<Selection>(new Set([]));
  /* CARATTERISTICHE / ASSISTENZA */
  const [traits, setTraits] = React.useState<TraitData[]>([]);
  /* CARATTERE BADANTE */
  const [personalities, setPersonalities] = React.useState<CareGiverPeronality[]>([]);
  /* INFO UTILI */
  const [nightTime, setNightTime] = React.useState<Selection>(new Set([]));
  const [weekendAvailability, setWeekendAvailability] = React.useState<Selection>(new Set([]));
  const [otherPeoplePresence, setOtherPeoplePresence] = React.useState<Selection>(new Set([])); 
  const [smokes, setSmokes] = React.useState<Selection>(new Set([]));
  /* ALTRO */
  const [referencesNumbers, setReferencesNumbers] = React.useState<string>('');
  const [notes, setNotes] = React.useState<string>('');
  // Traits NOTES
  const [traitNoteValue, setTraitNodeValue] = React.useState<string>('');
  const [selectedTrait, setSelectedTrait] = React.useState<Trait | null>(null);


  const [usefulInfo, setUsefulInfo] = React.useState<UsefulInfo[]>(DEFAULT_COMMON_USEFUL_INFO);


  const submit = async() => {
    try {
      if (!userProfile) return;
      setLoading(true);
      const careGiverFormData = getCareGiverFormData();
      /* for (let p of persone) {
        const cfd = brkRef(careGiverFormData);
        cfd.personalData.name = p.nome;
        cfd.personalData.surname = p.cognome;
        await createUserCareGiver(userProfile.uid, cfd);
      } */ 
      await createUserCareGiver(userProfile.uid, careGiverFormData);
      setLoading(false);
      toast.success('Badante creata con successo');
      navigate(-1);
      reset();
    } catch (error) {
      setLoading(false);
    }
  }

  const getCareGiverFormData = (): CareGiverFormData => {
    const calendarDate: CalendarDate = {
      day: birthDate?.day as number,
      month: birthDate?.month as number,
      year: birthDate?.year as number,
    };
    return {
      traits: traits,
      coockingKnowledge: Array.from(cookingKnowledge).length === 0 ? 0 : Number(Array.from(cookingKnowledge)[0]),
      languageKnowledge: Array.from(languageKnowledge).length === 0 ? 0 : Number(Array.from(languageKnowledge)[0]),
      personalities: personalities,
      yearsOfExperience: isNaN(parseInt(yearsOfExperience)) ? 0 : parseInt(yearsOfExperience),
      //usefulInfo: usefulInfo,
      nightTime: Array.from(nightTime).length === 0 ? '0' : Array.from(nightTime)[0] as CareGiverNightTime,
      otherPeoplePresence: Array.from(otherPeoplePresence).length === 0 ? '0' : Array.from(otherPeoplePresence)[0] as CareGiverOtherPeoplePresence,
      smokes: Array.from(smokes).length === 0 ? '0' : Array.from(smokes)[0] as CareGiverSmokes,
      weekendAvailability: Array.from(weekendAvailability).length === 0 ? '0' : Array.from(weekendAvailability)[0] as CareGiverWeekendAvailability,
      referencesNumbers,
      notes,
      personalData: {
        address: address,
        name: name,
        nationality: Array.from(nationality).length === 0 ? 'Italiana' : Array.from(nationality)[0] as CaregiverNationality,
        tsDateOfBirth: calendarDate2Timestamp(calendarDate),
        distanceFromFamily: distanceFromFamily,
        references: references,
        surname: surname,
        telephone: telephone,
        coverageAvailability: Array.from(coverageAvailability).length > 0 ? Array.from(coverageAvailability)[0] as CareGiverCovergaeAvailability : undefined
      }
    }
  }

  const reset = () => {
    setName('');
    setSurname('');
    setAddress('');
    setBirthDate(undefined);
    setTelephone('');
    setNationality(new Set([]));
    setReferences(false);
    setCoverageAvailability(new Set([]));
    setDistanceFromFamily('');
    setYearsOfExperience('');
    setLanguageKnowledge(new Set([]));
    setCookingKnowledge(new Set([]));
    setTraits([]);
    setPersonalities([]);
    setUsefulInfo(DEFAULT_COMMON_USEFUL_INFO);
  }

  /* TODO: DA SPOSTARE DENTRO COMPONENTE IN COMMEON FORM TABLE */
  const onAddPersonality = (
    pe: any
  ) => {
    const pers = Array.from(new Set(pe))[0] as CareGiverPeronality
    const idx = personalities.findIndex(el => el === pers);
    if (idx < 0) {
      setPersonalities(prev => {
        const newPersonalities = brkRef(prev);
        newPersonalities.push(pers);
        return newPersonalities;
      })
    }
  }

  const onRemovePersonality = (pers: CareGiverPeronality) => {
    setPersonalities(prev => {
      const newPersonalities = brkRef(prev);
      const idx = prev.findIndex(el => el === pers);
      if (idx >= 0) {
        newPersonalities.splice(idx, 1);
      }
      return newPersonalities
    });
  }

  const onRemoveTrait = (t: Trait) => {
    setTraits(prev => {
      const newTraits = brkRef(prev);
      const idx = prev.findIndex(el => el.trait === t);
      if (idx >= 0) {
        newTraits.splice(idx, 1);
      }
      return newTraits;
    });
  }

  const onAddTrait = (
    tr: any
  ) => {
    const t = Array.from(new Set(tr))[0] as Trait;
    const idx = traits.findIndex(el => el.trait === t);
    if (idx < 0) {
      setTraits(prev => {
        const newTraits = brkRef(prev);
        newTraits.push({trait: t, on: true});
        return newTraits;
      })
    }
  }

  const onToggleTrait = (trait: Trait) => {
    setTraits(prev => {
      const newTraits = brkRef(prev);
      const idx = prev.findIndex(el => el.trait === trait);
      if (idx >= 0) {
        newTraits[idx].on = !prev[idx].on;
      }
      return newTraits;
    })
  }

  const onTraitNoteEdit = () => {
    if (!selectedTrait) return;
    setTraits(prev => {
      const newTraits = brkRef(prev);
      const idx = newTraits.findIndex(el => el.trait === selectedTrait);
      if (idx >= 0) {
        newTraits[idx].note = traitNoteValue;
      }
      return newTraits;
    })
  }

  return (
    <PageLayout nestedPage>
      <div className='flex justify-between items-center'>
        <div className='flex flex-row gap-4 items-center'>
          <NUIButton isIconOnly aria-label="back" color='primary' size='sm' onClick={() => navigate(-1)} radius='full' >
            <ArrowBackIcon />
          </NUIButton>
          <p className='text-xl font-medium'>Nuova Badante</p>
        </div>
      </div>
      <div className='flex flex-col w-full h-full mt-6 p-4' style={{
        borderRadius: theme.sizing.x2,
        backgroundColor: theme.color.background,
        border: '1.5px solid lightgray'
      }}>
        <div className='w-full h-full mt-8'>
            {/* ======= ANAGRAFICA ======= */}
            <div>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  ANAGRAFICA
              </Typography>
              <div className='flex items-center gap-3 mt-3'>
                <Input value={name} onValueChange={setName} label="Nome" className='flex-[4]'/>
                <Input value={surname} onValueChange={setSurname} label="Cognome" className='flex-[4]'/>
                <DateInput label={"Data di nascita"} className='flex-[2]' value={birthDate} onChange={setBirthDate} isInvalid={false}/>
              </div>
              <div className='flex gap-4 mt-3'>
                <Input value={address} onValueChange={setAddress} label="Indirizzo" className='flex-[5]'/>
                <Input value={telephone} onValueChange={setTelephone} label="Numero di telefono" className='flex-[5]'/>
              </div>
              <div className='flex gap-4 mt-3'>
                <Select
                  className='flex-[5]'
                  label='Nazionalità'
                  selectedKeys={nationality}
                  onSelectionChange={setNationality}>
                    {
                      CAREGIVER_NATIONALITIES_SELECTOR_DATA.map((n) => (
                        <SelectItem key={n.key}>{n.value}</SelectItem>
                      ))
                    }
                  </Select>
                <Switch
                  isSelected={references}
                  onValueChange={() => setReferences(prev => !prev)}>
                    Referenze
                </Switch>
              </div>
              <Select 
                className='mt-3'
                label='Che tipo di lavoro cerchi?'
                selectedKeys={coverageAvailability}
                onSelectionChange={setCoverageAvailability}>
                  {
                    CAREGIVER_COVERAGE_AVAILABILITY.map((e) => (
                      <SelectItem key={e.key}>{e.value}</SelectItem>
                    ))
                  }
                </Select>
            </div>

            {/* ESPERIENZA E CONOSCENZE */}
            <div className='mt-8'>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  ESPERIENZA E CONOSCENZE
              </Typography>
              <Input value={yearsOfExperience} onValueChange={setYearsOfExperience} label="Anni di esperienza" className='w-60 mt-3'/>
              <div className='flex flex-wrap gap-3 mt-3'>
              <Select 
                label='Conoscenza italiano'
                selectedKeys={languageKnowledge}
                onSelectionChange={setLanguageKnowledge}>
                  {
                    KNOWEDGE_SELECTOR_DATA.map((e) => (
                      <SelectItem key={e.key}>{e.value}</SelectItem>
                    ))
                  }
                </Select>
                <Select 
                  label='Conoscenza cucina'
                  selectedKeys={cookingKnowledge}
                  onSelectionChange={setCookingKnowledge}>
                    {
                      KNOWEDGE_SELECTOR_DATA.map((e) => (
                        <SelectItem key={e.key}>{e.value}</SelectItem>
                      ))
                    }
                  </Select>
            </div>
            </div>


            {/* CARATTERISTICA ASSISTENZA */}
                <div className='mt-8'>
                  <Typography
                    style={{fontWeight: 700}} 
                    colorVariant='textTertiary'>
                      CONOSCENZE DELLA BADANTE
                  </Typography>
                  {
                    traits.length > 0 && (
                      <Table removeWrapper className='mt-3'>
                    <TableHeader>
                      <TableColumn>NOME CARATTERISTICA</TableColumn>
                      <TableColumn>NOTE</TableColumn>
                      <TableColumn> </TableColumn>
                    </TableHeader>
                    <TableBody>
                      {traits.map((ft, i) => (
                        <TableRow key={i}>
                          <TableCell className='flex items-center'>
                            <IconButton 
                              backgroundColorVariant='none'
                              onClick={() => onRemoveTrait(ft.trait)}
                              icon={<DeleteRoundedIcon style={{color: theme.color.primary}}/>}/>
                            <Typography colorVariant='primary' variant='button' style={{fontWeight: 600}}>{ft.trait}</Typography>
                          </TableCell>
                          <TableCell>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                              {
                                ft.note ? (
                                  <Typography variant='button' style={{
                                    flex: 1,
                                    whiteSpace: 'nowrap',
                                    maxWidth: '250px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}>{ft.note}</Typography>
                                ) : (
                                  <Typography variant='button' colorVariant='textLabel' style={{fontStyle: 'italic'}}>Nessuna nota</Typography>
                                )
                              }
                              <IconButton 
                                backgroundColorVariant='none'
                                onClick={() => {
                                  setTraitNodeValue(ft.note ?? '');
                                  setSelectedTrait(ft.trait);
                                }}
                                icon={<EditRoundedIcon style={{color: theme.color.primary}}/>}/>
                            </div>
                          </TableCell>
                          <TableCell>
                            <Switch
                              isSelected={ft.on}
                              onValueChange={() => onToggleTrait(ft.trait)} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                    )
                  } 
                  <div className='flex gap-4 items-center'>
              <Select
                className='mt-3'
                label="Seleziona una conoscenza" 
                selectedKeys={new Set([])}
                onSelectionChange={onAddTrait}>
                {TRAITS_SELECTOR_DATA.map((t) => (
                  <SelectItem key={t.key}>
                    {t.value}
                  </SelectItem>
                ))}
              </Select>
            </div>
                </div>
        

            {/* CARATTERE BADANTE */}
            <div className='mt-8'>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  CARATTERE
              </Typography>
              {
                personalities.length > 0 && (
                  <Table removeWrapper className='mt-3'>
                    <TableHeader>
                      <TableColumn>CARATTERE</TableColumn>
                    </TableHeader>
                    <TableBody>
                      {personalities.map((ft, i) => (
                        <TableRow key={i}>
                          <TableCell className='flex items-center'>
                            <IconButton 
                              backgroundColorVariant='none'
                              onClick={() => onRemovePersonality(ft)}
                              icon={<DeleteRoundedIcon style={{color: theme.color.primary}}/>}/>
                            <Typography colorVariant='primary' variant='button' style={{fontWeight: 600}}>{ft}</Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>    
                )
              }
              <div className='flex gap-4 items-center'>
                <Select
                  className='mt-3'
                  label="Seleziona un carattere" 
                  selectedKeys={new Set([])}
                  onSelectionChange={onAddPersonality}>
                  {CARE_GIVER_PERSONALITIES_SELECTOR_DATA.map((personality) => (
                    <SelectItem key={personality.key}>
                      {personality.value}
                    </SelectItem>
                  ))}
                </Select>
              </div>
            </div>

            {/* INFO UTILI */}
            <div className='mt-8'>
        <p>INFO UTILI PER BADANTE</p>
        <div className='flex flex-col gap-4 mt-4'>
          {/*
            usefulInfo.map((ui, i) => (
              <div className='flex flex-row gap-4' key={i}>
                <div className='flex flex-1'>
                  <p>{ui.name}</p>
                </div>
                <Switch 
                  isSelected={ui.value}
                  onValueChange={() => {
                    setUsefulInfo(prev => {
                      const newUsefulInfo = brkRef(prev);
                      newUsefulInfo[i].value = !newUsefulInfo[i].value;
                      return newUsefulInfo;
                    })
                  }} />
              </div>
            ))
          */}
          <Select
            className='mt-1'
            label="Disponibilità ad alzarsi di notte" 
            selectionMode='single'
            selectedKeys={nightTime}
            onSelectionChange={setNightTime}>
            {CAREGIVERS_NIGHT_TIME.map((nt) => (
              <SelectItem key={nt.key}>
                {nt.value}
              </SelectItem>
            ))}
          </Select>
          <Select
            className='mt-1'
            label="Disponibilità al lavoro nel weekend" 
            selectionMode='single'
            selectedKeys={weekendAvailability}
            onSelectionChange={setWeekendAvailability}>
            {CAREGIVER_WEEKEND_AVAILABILIY.map((wa) => (
              <SelectItem key={wa.key}>
                {wa.value}
              </SelectItem>
            ))}
          </Select>
          <Select
            className='mt-1'
            label="Fuma" 
            selectionMode='single'
            selectedKeys={smokes}
            onSelectionChange={setSmokes}>
            {CAREGIVER_SMOKES.map((s) => (
              <SelectItem key={s.key}>
                {s.value}
              </SelectItem>
            ))}
          </Select>
          <Select
            className='mt-1'
            label="Disponibilità a lavorare con altre persone" 
            selectionMode='single'
            selectedKeys={otherPeoplePresence}
            onSelectionChange={setOtherPeoplePresence}>
            {CAREGIVER_OTHER_PEOPLE_PRESENCE.map((pp) => (
              <SelectItem key={pp.key}>
                {pp.value}
              </SelectItem>
            ))}
          </Select>
        </div>
      </div>

            {/* ALTRO */}
            <div className='mt-8'>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  ALTRO
              </Typography>
              <div className='mt-2 flex flex-col gap-4'>
                <Textarea 
                  label={'Numeri per referenze'} 
                  placeholder='Numeri di telefono e nominativi per le referenze'
                  value={referencesNumbers}
                  onValueChange={setReferencesNumbers} />
                <Textarea label='Note' placeholder='Inserisci note'
                value={notes}
                onValueChange={setNotes} />
              </div>
            </div>

          </div>
          <div className='flex flex-col gap-4 mt-16'>
            <Button 
              title='Salva badante'
              onClick={submit}/>
            <Button 
              title='Annulla'
              variant='secondary'
              onClick={() => navigate(-1)} />
          </div>
      </div>
      <CustomModal
        isOpen={!!selectedTrait}
        onOpenChange={() => setSelectedTrait(null)}
        content={
          <div style={{
            display: 'flex',
            flex: 1,
            paddingTop: theme.sizing.x5,
            flexDirection: 'column',
            gap: theme.sizing.x4,
          }}>
            <div style={{display: 'flex', gap: theme.sizing.x2, flexDirection: 'column'}}>
              <Typography 
                variant='headline3'
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>Modifica Nota</Typography>
              <Textarea label='Note' placeholder='Inserisci note'
                maxLength={100}
                value={traitNoteValue}
                onValueChange={setTraitNodeValue} />
            </div>
             <div style={{display: 'flex', gap: theme.sizing.x1, marginLeft: 'auto'}}>
              <Button 
                title='Chiudi'
                onClick={() => {
                  setTraitNodeValue('');
                  setSelectedTrait(null);
                }} />
                <Button  
                  title='Salva'
                  onClick={() => {
                    onTraitNoteEdit();
                    setTraitNodeValue('');
                    setSelectedTrait(null);
                  }}/>
             </div>
          </div>
        } />
    </PageLayout>
  )
}